import React, { useState } from 'react';
import { FormControlLabel, Switch, Checkbox } from '@mui/material';
import RestaurantSelection from './RestaurantSelection';

const CloneItemComponent = ({
    propsRestaurantId,
    setPropsRestaurantId,
    handleCloneItems,
    isSelectable,
    setIsSelectable,
    isSelectAll,
    setIsSelectAll,
    cloneItemLabel = "Clone Item",
}) => {
    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        checked={isSelectable}
                        onChange={(e) => {
                            setIsSelectable(e.target.checked);
                            if (!e.target.checked) {
                                setIsSelectAll(false);
                            }
                        }}
                        color="primary"
                    />
                }
                label={cloneItemLabel}
                labelPlacement="end"
            />
            {isSelectable && (
                <>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={isSelectAll}
                                onChange={(e) => setIsSelectAll(e.target.checked)}
                                color="primary"
                            />
                        }
                        label="Select All"
                        labelPlacement="end"
                    />
                    <RestaurantSelection
                        className="d-flex"
                        labelClassName="pt-2 me-2 hidden"
                        multiSelect={false}
                        isSingleUse={true}
                        propsRestaurantId={propsRestaurantId}
                        setPropsRestaurantId={setPropsRestaurantId}
                    />
                    <div style={{ marginLeft: '16px' }}>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => handleCloneItems()}
                        >
                            Clone
                        </button>
                    </div>
                </>
            )}
        </>
    );
};

export default CloneItemComponent;
